import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { fetchPracticeTimeline } from '../services/practiceTimeline';
import { PRACTICE_TIMELINE_KEY } from './queryKeys';

const STALE_TIME_MS = 60_000;

/**
 * One practice's merged timeline. `keepPreviousData` so paging back through
 * history doesn't blank the panel between pages - an audit log is read by
 * scanning, and a flash of empty on every page turn makes that harder than
 * it needs to be.
 */
export function usePracticeTimeline(practiceId: string, page: number, limit: number) {
    const { data, isLoading, isError, refetch } = useQuery({
        queryKey: [...PRACTICE_TIMELINE_KEY(practiceId), page, limit],
        queryFn: () => fetchPracticeTimeline(practiceId, page, limit),
        staleTime: STALE_TIME_MS,
        placeholderData: keepPreviousData,
        enabled: Boolean(practiceId)
    });

    return {
        entries: data?.data ?? [],
        meta: data?.meta ?? { total: 0, page, limit, totalPages: 1 },
        isLoading,
        isError,
        refetch
    };
}
